import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';

import { LocalizationService } from '../../Core/Localization/services/localization.service';
import { BrandIdentity } from '../../Common/BrandIdentity/models/brand-identity';
import { ViBrandContextApi } from '../../api/visibilityIntelligence/models/vi-brand-context.api.model';
import { ViBrandIdentity } from '../models/vi-brand-identity.model';


export enum InfoTypesEnum {
    brandVoice,
    keyValue,
    missionStatement,
    productsAndServices,
    tagline,
    custom
}

@Injectable()
export class ViBrandCardService {
    constructor(private localizationService: LocalizationService) {}

    buildAdditionalInfoActions(): MenuItem[] {
        return [
            {
                key: InfoTypesEnum.brandVoice,
                label: this.localizationService.transform('Common.brandInformation.voice.label'),
                maxLimit: 1
            },
            {
                key: InfoTypesEnum.keyValue,
                label: this.localizationService.transform('Common.brandInformation.keyValuePropositions.label'),
                maxLimit: 1
            },
            {
                key: InfoTypesEnum.missionStatement,
                label: this.localizationService.transform('VisibilityIntelligence.brandSetupPanel.card.addtionalInfo.missionStatement'),
                maxLimit: 1
            },
            {
                key: InfoTypesEnum.productsAndServices,
                label: this.localizationService.transform('Common.brandInformation.products.label'),
                maxLimit: 1
            },
            {
                key: InfoTypesEnum.tagline,
                label: this.localizationService.transform('Common.brandInformation.tagline.label'),
                maxLimit: 1
            },
            {
                key: InfoTypesEnum.custom,
                label: this.localizationService.transform('VisibilityIntelligence.brandSetupPanel.card.addtionalInfo.custom'),
                isCustomType: true
            },
        ];
    }

    getBrandInfoValue(brand: BrandIdentity, key: InfoTypesEnum): string {
        switch (key) {
            case InfoTypesEnum.brandVoice:
                return brand.brandVoice ?? '';
            case InfoTypesEnum.keyValue:
                return brand.keyValuePropositions ?? '';
            case InfoTypesEnum.missionStatement:
                return brand.missionStatement ?? '';
            case InfoTypesEnum.productsAndServices:
                return brand.products ?? '';
            case InfoTypesEnum.tagline:
                return brand.tagline ?? '';
            default:
                return '';
        }
    }

    // builds a fully-populated ViBrandIdentity from a BrandIdentity, e.g. right after a fresh brand selection
    toViBrandIdentity(brand: BrandIdentity, isCompetitor: boolean = false): ViBrandIdentity {
        const additionalContext: ViBrandContextApi[] = [
            ...this.buildAdditionalInfoActions()
                .map(action => ({ contextTitle: action.label ?? '', contextInfo: this.getBrandInfoValue(brand, action.key) }))
                .filter(entry => !!entry.contextTitle && !!entry.contextInfo),
            ...(brand.customInfo ?? []).map(info => ({ contextTitle: info.title, contextInfo: info.info }))
        ];

        return (isCompetitor ? {
            brandId: brand.id,
            name: brand.name ?? '',
            nameVariations: brand.nameVariations ? [...brand.nameVariations] : [],
            websites: brand.websites ? [...brand.websites] : [],
        } : {
            brandId: brand.id,
            name: brand.name ?? '',
            nameVariations: brand.nameVariations ? [...brand.nameVariations] : [],
            websites: brand.websites ? [...brand.websites] : [],
            industry: brand.industry ?? '',
            bio: brand.bio ?? '',
            additionalContext,
        }) as ViBrandIdentity;
    }
}
